import { adaptV4Theme, createTheme } from '@mui/material/styles';

import COLORS from './colors';
import { fossaPrimaryFont } from './typography';

/**
 * Material UI Theme
 */
export const styles = {
  typography: {
    fontFamily: fossaPrimaryFont,
  },
  palette: {
    primary: {
      main: COLORS.fossaGreen,
    },
    secondary: {
      main: COLORS.fossaSlateBlue,
    },
    text: {
      primary: COLORS.fossaMidnightBlue,
    },
  },
  overrides: {
    MuiButton: {
      text: {
        fontSize: '1rem',
      },
    },
    MuiCheckbox: {
      root: {
        height: 'inherit',
      },
      colorSecondary: {
        '&.Mui-checked': {
          color: COLORS.fossaGreen,
        },
      },
    },
    MuiFormControlLabel: {
      label: {
        fontWeight: 700,
        fontSize: '1rem',
      },
    },
  },
  raisedButton: {
    primaryColor: COLORS.fossaGreen,
    disabledColor: COLORS.fossaGray20,
  },
  flatButton: {
    primaryTextColor: COLORS.fossaGreen,
    disabledColor: COLORS.fossaGray20,
    fontWeight: 700,
  },
  statuses: {
    error: COLORS.fossaRed,
    success: COLORS.fossaGreen,
    warning: COLORS.fossaYellow,
    disabled: COLORS.fossaGray20,
  },
  backgrounds: {
    light: COLORS.fossaGray05,
    dark: COLORS.fossaSlateBlue,
  },
  spacing: 15, // Grid size
};

export const theme = createTheme(adaptV4Theme(styles));
